import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { isHelixOnlyHub } from 'utils/helix';
import config from 'utils/config';
import { useFetchUserMindsetSettings } from 'actions/userProfile';
import PageSection from 'components/PageSection';
import UserPageHeader from 'components/UserPageHeader';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import Card from 'components/Card';
import Text from 'components/Text';
import Button from 'components/Button';
import Panel from 'components/Panel';
import Flex from 'components/Flex';
import CenterContent from 'components/CenterContent';
import Landmark from 'components/Landmark';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import OnboardingMindsetCard from '../components/OnboardingMindsetCard';
import HelixEmailLink from '../components/HelixEmailLink';
import SettingsLink from '../components/SettingsLink';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function HowHelixWorksText(_ref) {
  var headingProps = _ref.headingProps,
    stackProps = _ref.stackProps;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, _objectSpread(_objectSpread({
      as: "h3",
      size: "medium",
      mb: "m"
    }, headingProps), {}, {
      children: t('skills_empty_how_helix_works_title')
    })), /*#__PURE__*/_jsxs(Stack, _objectSpread(_objectSpread({
      spacing: "s"
    }, stackProps), {}, {
      children: [/*#__PURE__*/_jsxs(Trans, {
        i18nKey: "skills_empty_how_helix_works_text_1",
        children: ["Helix will attend any meeting to which", /*#__PURE__*/_jsx(HelixEmailLink, {
          children: "helix@5app.com"
        }), "is invited."]
      }), ['skills_empty_how_helix_works_text_2', 'skills_empty_how_helix_works_text_3', 'skills_empty_how_helix_works_text_4', 'skills_empty_how_helix_works_text_5'].map(function (key) {
        return /*#__PURE__*/_jsx(Text, {
          children: t(key)
        }, key);
      })]
    }))]
  });
}
export function HelixChangeMyMindText(_ref2) {
  var headingProps = _ref2.headingProps,
    stackProps = _ref2.stackProps;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, _objectSpread(_objectSpread({
      as: "h3",
      size: "medium",
      mb: "m"
    }, headingProps), {}, {
      children: t('skills_empty_mind_changed_title')
    })), /*#__PURE__*/_jsx(Stack, _objectSpread(_objectSpread({
      spacing: "s"
    }, stackProps), {}, {
      children: ['skills_empty_mind_changed_text_1', 'skills_empty_mind_changed_text_2', 'skills_empty_mind_changed_text_3', 'skills_empty_mind_changed_text_4'].map(function (key) {
        return /*#__PURE__*/_jsx(Text, {
          children: t(key)
        }, key);
      })
    }))]
  });
}
function WelcomePage(_ref3) {
  var user = _ref3.user;
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  var _useFetchUserMindsetS = useFetchUserMindsetSettings(),
    hasMindsetAgent = _useFetchUserMindsetS.hasMindsetAgent,
    isMindsetAgentLoading = _useFetchUserMindsetS.isLoading;
  var showAgentCard = config.showAgentInHelixPages && hasMindsetAgent;
  if (config.showAgentInHelixPages && isMindsetAgentLoading) {
    return /*#__PURE__*/_jsx(CenterContent, {
      fillParent: true,
      children: /*#__PURE__*/_jsx(Landmark, {
        icon: "spinner"
      })
    });
  }
  if (showAgentCard) {
    return /*#__PURE__*/_jsx(PageSection, {
      flush: true,
      children: /*#__PURE__*/_jsxs(Stack, {
        spacing: "l",
        mb: "m",
        mt: "xxl",
        children: [/*#__PURE__*/_jsxs(Flex, {
          gap: "s",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(CoachAiAvatar, {}), /*#__PURE__*/_jsx(Heading, {
            as: "h2",
            children: t('skills_empty_welcome_title')
          })]
        }), /*#__PURE__*/_jsx(OnboardingMindsetCard, {})]
      })
    });
  }
  return /*#__PURE__*/_jsx(PageSection, {
    flush: true,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "l",
      maxWidth: 860,
      mb: "m",
      mt: isHelixOnlyHub ? 'm' : '0',
      children: [user && /*#__PURE__*/_jsx(UserPageHeader, _objectSpread({}, user)), /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        children: t('skills_empty_welcome_title')
      }), /*#__PURE__*/_jsxs(Card, {
        p: "m",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h3",
          size: "medium",
          mb: "m",
          children: t('skills_empty_get_started_title')
        }), /*#__PURE__*/_jsxs(Stack, {
          spacing: "s",
          children: [/*#__PURE__*/_jsx(Text, {
            children: t('skills_empty_get_started_text_1')
          }), /*#__PURE__*/_jsxs(Trans, {
            i18nKey: "skills_empty_get_started_text_2",
            children: ["It couldn\u2019t be easier \u2013 simply invite", /*#__PURE__*/_jsx(HelixEmailLink, {
              children: "helix@5app.com"
            }), "to your next meeting and it will automatically start tracking your skills."]
          }), /*#__PURE__*/_jsx(Text, {
            children: t('skills_empty_get_started_text_3')
          })]
        })]
      }), config.userCalendarIntegration && /*#__PURE__*/_jsxs(Card, {
        p: "m",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h3",
          size: "medium",
          mb: "m",
          children: t('skills_empty_auto_join_title')
        }), /*#__PURE__*/_jsxs(Stack, {
          spacing: "s",
          children: [/*#__PURE__*/_jsx(Text, {
            children: t('skills_empty_auto_join_text_1')
          }), /*#__PURE__*/_jsxs(Trans, {
            i18nKey: "skills_empty_auto_join_text_2",
            children: ["No need to manually invite", /*#__PURE__*/_jsx(HelixEmailLink, {
              children: "helix@5app.com"
            }), "to the meeting - Helix will join based on your preferences."]
          }), /*#__PURE__*/_jsxs(Trans, {
            i18nKey: "skills_empty_auto_join_text_3",
            children: ["You can edit your meeting preferences or unlink your calendar at any time via your", /*#__PURE__*/_jsx(SettingsLink, {
              children: "Settings"
            }), "page"]
          }), /*#__PURE__*/_jsx(Text, {
            children: t('skills_empty_auto_join_text_4')
          }), /*#__PURE__*/_jsx(Panel, {
            align: "center",
            flush: true,
            children: /*#__PURE__*/_jsx(Button, {
              icon: "calendar",
              variant: "primary",
              as: Link,
              to: "/settings",
              children: t('actions_go_to_settings')
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(Card, {
        p: "m",
        children: /*#__PURE__*/_jsx(HowHelixWorksText, {})
      }), /*#__PURE__*/_jsx(Card, {
        p: "m",
        children: /*#__PURE__*/_jsx(HelixChangeMyMindText, {})
      })]
    })
  });
}
export default WelcomePage;